import { on } from "svelte/events";
import { useTimeoutEx } from "@otto-ec/otto-components-utils/svelte/useTimeout";
import {
  ITEM_VISIBILITY_CHANGED_EVENT,
  STAGE_SCROLL_COMPLETED_EVENT,
  STAGE_SCROLL_EVENT,
  type ScrollSource,
  type useScrollEvents,
} from "./events";
import type { CinemaItemState } from "./itemState.svelte";

export type StageScrollState = {
  /*                                                                                                        */
  readonly stageScrollLeft: number;
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const useStageScrollEvent = (
  itemState: CinemaItemState,
  stage: () => HTMLElement | undefined,
  dispatchScrollEvent: ReturnType<typeof useScrollEvents>,

  stageScrollSource: () => ScrollSource | undefined,

  updateStageScrolling: (scrolling: boolean) => void,
  updateStageScrollSource: (source: ScrollSource) => void,
): StageScrollState => {
  const state = $state({ stageScrollLeft: 0 });

  /*                                           */
  const queueIntersectionFinished = useTimeoutEx(() => {
    if (itemState.isEqual()) return;

    updateStageScrolling(false);

    if (stageScrollSource() !== undefined)
      dispatchScrollEvent(
        STAGE_SCROLL_EVENT,
        ITEM_VISIBILITY_CHANGED_EVENT,
        STAGE_SCROLL_COMPLETED_EVENT,
      );

    itemState.synchronize();
    updateStageScrollSource("swipe");
  }, 500);

  /*                                                                  */
  $effect(() => {
    const stageElement = stage();
    if (!stageElement) return;

    const onScrollHandler = (): void => {
      state.stageScrollLeft = stageElement.scrollLeft;
      updateStageScrolling(true);
      queueIntersectionFinished();
    };

    return on(stageElement, "scroll", onScrollHandler, { passive: true });
  });

  return state;
};
